import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ISettingsConfigComponent } from '../../models/util/settingsConfig';
import { RouteEnum } from '../../enums/routes.enum';
import { MaterialModule } from '../../material/material.module';
import { FormsModule } from '@angular/forms';
import { PipesModule } from '../../pipes/pipes.module';
import { PurchaseLabelComponent } from '../../shared/purchase-label/purchase-label.component';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-settings-purchase-history',
	standalone: true,
	imports: [
		MaterialModule,
		PipesModule,
		FormsModule,
		PurchaseLabelComponent,
		CommonModule
	],
	templateUrl: './settings-purchase-history.component.html',
	styleUrl: './settings-purchase-history.component.scss'
})
export class SettingsPurchaseHistoryComponent implements ISettingsConfigComponent, OnInit {

	@ViewChild('receiptTemplate', { static: true }) receiptTemplate: TemplateRef<any>;
	@ViewChild('amountTemplate', { static: true }) amountTemplate: TemplateRef<any>;
	@ViewChild('dateTemplate', { static: true }) dateTemplate: TemplateRef<any>;
	@ViewChild('cardTemplate', { static: true }) cardTemplate: TemplateRef<any>;
	@ViewChild('paymentTemplate', { static: true }) paymentTemplate: TemplateRef<any>;
	@ViewChild('downloadTemplate', { static: true }) downloadTemplate: TemplateRef<any>;

	columns: string[] = ['receipt', 'product', 'amount', 'date', 'card', 'payment_status', 'download'];
	columnsTemplates: TemplateRef<any>[] = [];
	columnLabels: string[] = ['account.receipt', 'account.product', 'account.amount', 'account.date', 'account.card', 'account.payment_status', ''];

	// TODO: consume real data from db whenever it is available, remove this dummy data
	data: any = [
		{
			'receipt': 1,
			'product': "Product 1",
			'amount': 100,
			'date': new Date(2025, 6, 13),
			'card': "---- ---- 1234",
			'payment_status': 0,
		},
		{
			'receipt': 2,
			'product': "Product 2",
			'amount': 100,
			'date': new Date(),
			'card': "---- ---- 4321",
			'payment_status': 1,
		},
	]

	ngOnInit(): void {
		this.columnsTemplates = [this.receiptTemplate, null, this.amountTemplate, this.dateTemplate, this.cardTemplate, this.paymentTemplate, this.downloadTemplate];
	}

	hasDataChanged(): boolean {
		return false;
	}

	async downloadReceipt(): Promise<void> {
		// TBD
	}

}
